export default function LoginHistoryTable({ records = [], startIndex = 0 }) {
  if (!records?.length) {
    return (
      <div className="text-center py-8 lg:py-16 px-4">
        <div className="inline-flex items-center justify-center w-12 h-12 lg:w-16 lg:h-16 rounded-full bg-gray-100 mb-3 lg:mb-4">
          <svg
            className="w-6 h-6 lg:w-8 lg:h-8 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        </div>
        <p className="text-gray-500 font-medium text-sm lg:text-base">
          No login history records found
        </p>
        <p className="text-xs lg:text-sm text-gray-400 mt-1">
          Records will appear here once users log in
        </p>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const dateOnly = date.toLocaleDateString();
    const timeOnly = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    return { date: dateOnly, time: timeOnly };
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full divide-y divide-gray-200 text-xs lg:text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap">
              No
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap">
              Business Name
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap hidden sm:table-cell">
              Email
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap">
              Status
            </th>
            <th className="px-2 lg:px-4 py-2 lg:py-3 text-left font-semibold text-gray-600 whitespace-nowrap text-right">
              Login Time
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {records.map((record, index) => (
            <tr
              key={record.id || index}
              className={`hover:bg-gray-50 transition-colors duration-150 ${
                record.login_status === "failed" || record.status === "failed"
                  ? "bg-red-50/50"
                  : ""
              }`}
            >
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap font-medium text-gray-900">
                {startIndex + index + 1}
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap text-gray-700">
                <div className="text-sm">
                  <div className="font-medium text-gray-900">
                    {record.business_name || "N/A"}
                  </div>
                  <div className="text-xs text-gray-500 sm:hidden">
                    {record.email || "N/A"}
                  </div>
                </div>
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap text-gray-700 hidden sm:table-cell">
                <span className="text-sm">{record.email || "N/A"}</span>
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap">
                {record.login_status === "success" ||
                record.status === "success" ? (
                  <span className="px-2 py-1 inline-flex text-xs font-semibold rounded-full bg-green-100 text-green-800">
                    ✓ Success
                  </span>
                ) : (
                  <span className="px-2 py-1 inline-flex text-xs font-semibold rounded-full bg-red-100 text-red-800">
                    ✗ Failed
                  </span>
                )}
              </td>
              <td className="px-2 lg:px-4 py-2 lg:py-3 whitespace-nowrap text-gray-600 text-right text-xs lg:text-sm">
                {(() => {
                  const formatted = formatDate(record.login_time);
                  return typeof formatted === "object" ? (
                    <div className="flex flex-col">
                      <span className="font-medium">{formatted.date}</span>
                      <span className="text-gray-500">{formatted.time}</span>
                    </div>
                  ) : (
                    formatted
                  );
                })()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
